<template>
  <div>
    <div
      class="wrapper"
      @mouseover="changePicture()"
      @mouseout="changePictureToMainpicture()"
    >
      <div class="img-wrapper">
        <img
          :src="getImagePath(mainPicture)"
          alt=""
        >
      </div>
      <div class="product-info">
        <h3>{{ product.title }}</h3>
        <p>{{ product.price }} PLN</p>
      </div>
    </div>
  </div>
</template>

<script>

import storageUrl from '@/consts/api'

export default {
  name: 'Products',
  props: {
    product: Object
  },
  data: function () {
    return {
      mainPicture: this.product.mainPhoto
    }
  },
  methods: {
    getImagePath (productImgPath) {
      return `${storageUrl}${productImgPath}`
    },

    changePicture () {
      this.mainPicture = this.product.photos[0]
    },

    changePictureToMainpicture () {
      this.mainPicture = this.product.mainPhoto
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSSn to this component only -->
<style scoped lang="scss">
.wrapper {
  width: 90%;
  cursor: pointer;
  margin: 0 auto;
  height: 100%;
}
.img-wrapper {
  overflow: hidden;
  width: 100%;
}
.img-wrapper img {
  width: 100%;
  object-fit: cover;
}
.product-info {
  margin-top: 20px;
  text-transform: uppercase;
  font-size: 1rem;
  color: gray;
}

.product-info h3 {
  font-size: 1.2rem;
  font-weight: bold;
  letter-spacing: 3px;
}

.product-info p {
  letter-spacing: 2px;
}

@media (min-width: 992px) {
  .product-info {
    margin-top: 50px;
    font-size: 2rem;
    color: gray;
  }
}
</style>
